import {CircleCheckIcon, InfoIcon, TriangleAlertIcon, OctagonXIcon} from 'lucide-react';
import {Toaster as Sonner, type ToasterProps} from 'sonner';

import {Spinner} from './spinner';

import type {CSSProperties} from 'react';

const Toaster = ({...props}: ToasterProps) => {
  return (
    <Sonner
      theme="system"
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Spinner />
      }}
      style={
        {
          '--normal-bg': 'var(--background-surface)',
          '--normal-text': 'var(--fg)',
          '--normal-border': 'var(--border)',
          '--success-bg': 'var(--background-success)',
          '--success-text': 'var(--fg)',
          '--success-border': 'var(--border-success)',
          '--error-bg': 'var(--background-error)',
          '--error-text': 'var(--fg)',
          '--error-border': 'var(--border-error)',
          '--warning-bg': 'var(--background-warning)',
          '--warning-text': 'var(--fg)',
          '--warning-border': 'var(--border-warning)',
          '--info-bg': 'var(--background-info)',
          '--info-text': 'var(--fg)',
          '--info-border': 'var(--border-info)',
          '--border-radius': 'var(--radius)'
        } as CSSProperties
      }
      toastOptions={{
        classNames: {
          toast: 'cn-toast'
        },
        style: {minWidth: 0, width: 'max-content'}
      }}
      {...props}
    />
  );
};

export {Toaster};
